import { loadModules } from 'esri-loader';

export default class Locate {
  constructor(view) {
    this.startup(view);
  }

  startup(view) {
    loadModules(['esri/widgets/Locate']).then(([Locate]) => {
      this.widget = new Locate({
        view
      });
      view.ui.add(this.widget, 'top-left');
    });
  }
}



// WEBPACK FOOTER //
// ./src/esri/widgets/Locate.js